import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Clear({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.1686 6.76247C37.3022 6.51111 37.2052 6.19405 36.9538 6.06045C36.7025 5.92685 36.3854 6.02384 36.2518 6.2752L24.512 28.3628L24.5106 28.3656C24.6954 28.4467 24.8651 28.5296 25.0162 28.6099C25.1491 28.6805 25.2879 28.7595 25.4306 28.8468L37.1686 6.76247ZM26.9796 30.0642C27.0647 29.9879 27.1381 29.8956 27.1948 29.7888L38.9346 7.70114C39.5866 6.47442 39.1192 4.94642 37.8925 4.29441C36.6658 3.6424 35.1378 4.10981 34.4858 5.33653L22.746 27.4242C22.681 27.5464 22.644 27.676 22.6326 27.8057C21.5535 27.6298 20.2918 27.6704 19.013 28.2121C17.5242 28.8427 16.1228 30.1057 14.985 32.2464C14.2659 33.5994 13.2032 34.5993 11.2878 35.3504C10.3353 35.7213 9.48396 35.8547 8.9069 35.9087C8.46701 35.9498 8.10625 36.2748 8.0195 36.708C7.93275 37.1412 8.14057 37.58 8.5307 37.7873L20.1554 43.966C20.3376 44.0628 20.5453 44.1009 20.75 44.0751C20.9901 44.0447 22.199 43.8089 23.6148 43.0968C25.0405 42.3798 26.7441 41.1449 27.8417 39.0799C29.0109 36.8801 29.2293 34.954 28.8444 33.3248C28.5176 31.9416 27.7772 30.8616 26.9796 30.0642ZM25.2654 31.1983C24.8539 30.8388 24.4313 30.5639 24.0775 30.3759C23.7264 30.1893 23.2246 29.9786 22.6755 29.8518L22.6737 29.8514C21.7974 29.6474 20.7901 29.6314 19.793 30.0537C18.8051 30.4722 17.7172 31.3674 16.751 33.1851C15.7861 35.0006 14.3323 36.305 12.0168 37.2128L12.0148 37.2136C11.9556 37.2366 11.8968 37.2589 11.8384 37.2805L13.4777 38.1517C14.1171 38.0857 15.163 37.896 16.2364 37.2951C16.7184 37.0254 17.3277 37.1974 17.5975 37.6793C17.8672 38.1612 17.6952 38.7706 17.2133 39.0403C16.842 39.2482 16.4744 39.4176 16.1196 39.556L17.5846 40.3346C18.4256 40.249 19.9644 39.9467 21.3455 38.7835L21.3464 38.7827C22.0357 38.2038 22.4888 37.575 22.7803 37.08C23.0605 36.6041 23.6735 36.4454 24.1494 36.7257C24.6253 37.0059 24.784 37.6189 24.5037 38.0948C24.1288 38.7314 23.5386 39.553 22.6338 40.3133C21.8346 40.9864 21 41.4366 20.2264 41.7388L20.7771 42.0315C20.8823 42.006 21.0149 41.9712 21.1703 41.9249C21.5798 41.8029 22.1246 41.6076 22.7162 41.3101C23.9044 40.7125 25.2321 39.7283 26.0756 38.1412C27.0575 36.2939 27.1528 34.8633 26.898 33.7846C26.639 32.6884 25.9882 31.8294 25.2656 31.1985L25.2654 31.1983Z"
        fill="#141A21"
      />
    </SvgIconComponent>
  )
}

export function Deactivate({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 10.5L39.75 6C40.9927 6 42 7.00737 42 8.25V12.75L6 17.25V12.75C6 11.5074 7.00737 10.5 8.25 10.5Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 30.75C26.4853 30.75 28.5 28.7353 28.5 26.25C28.5 23.7647 26.4853 21.75 24 21.75C21.5147 21.75 19.5 23.7647 19.5 26.25C19.5 28.7353 21.5147 30.75 24 30.75Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 19.5V42H10.5V23.4375"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Delete({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M37.0042 23.2991V33.5443C37.0042 37.6314 35.3906 40.9434 31.3078 40.9434H17.2212C13.1384 40.9434 11.5247 37.6229 11.5247 33.5316V23.2991M17.8777 23.2779V34.8403M24.2666 23.2779V34.8403M30.6577 23.2779V34.8403M28.504 11.6987C28.5172 11.0814 28.407 10.4678 28.1799 9.8937C27.9528 9.31962 27.6134 8.79666 27.1816 8.35547C26.7497 7.91429 26.2341 7.56377 25.665 7.32447C25.0959 7.08517 24.4848 6.96191 23.8674 6.96191C23.2501 6.96191 22.6389 7.08517 22.0698 7.32447C21.5007 7.56377 20.9851 7.91429 20.5533 8.35547C20.1214 8.79666 19.782 9.31962 19.5549 9.8937C19.3278 10.4678 19.2176 11.0814 19.2308 11.6987M40.9388 15.0001C40.9399 14.1348 40.5976 13.3044 39.9869 12.6913C39.3762 12.0783 38.5472 11.7327 37.6819 11.7304H10.3155C9.88755 11.7307 9.46381 11.8153 9.06851 11.9793C8.67321 12.1433 8.31409 12.3836 8.01165 12.6865C7.70922 12.9893 7.46939 13.3487 7.30587 13.7442C7.14234 14.1398 7.05832 14.5636 7.05859 14.9916C7.05832 15.4196 7.14234 15.8434 7.30587 16.2389C7.46939 16.6345 7.70922 16.9939 8.01165 17.2967C8.31409 17.5995 8.67321 17.8398 9.06851 18.0039C9.46381 18.1679 9.88755 18.2525 10.3155 18.2528H37.6777C38.5394 18.2556 39.367 17.9161 39.9785 17.3089C40.5901 16.7018 40.9355 15.8766 40.9388 15.0149V15.0001Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Download({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M42 29.9993V35.9996C42 37.591 41.3679 39.1173 40.2426 40.2426C39.1173 41.3679 37.591 42 35.9996 42H12.0004C10.409 42 8.88272 41.3679 7.75743 40.2426C6.63214 39.1173 6 37.591 6 35.9996V29.9993"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 6V32.9983"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M15.0059 24.5251L23.0199 32.5391C23.3028 32.8209 23.6859 32.9791 24.0852 32.9791C24.4846 32.9791 24.8676 32.8209 25.1506 32.5391L32.9979 24.6916"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </SvgIconComponent>
  )
}

export function EditMedia({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M28 8L10.25 8C9.12283 8 8.04189 8.44776 7.24486 9.24479C6.44783 10.0418 6 11.1228 6 12.25V37.75C6 38.8772 6.44783 39.9582 7.24486 40.7552C8.04189 41.5522 9.12283 42 10.25 42H35.75C36.8772 42 37.9581 41.5522 38.7551 40.7552C39.5522 39.9582 40 38.8772 40 37.75V20"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2347 10.3896L19.4647 24.1657L18 30L23.8343 28.5352L39.5139 12.8556L35.1444 8.48606L36.7266 6.90388C37.9318 5.69871 39.8909 5.69871 41.0961 6.90388C41.9329 7.74068 42.1887 8.94098 41.8635 10C41.7203 10.4662 41.4645 10.905 41.0961 11.2734"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}
export function Edit({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M28.852 12.5845L8.19712 33.2486L6 42L14.7514 39.8029L38.2709 16.2834L31.7166 9.7291L34.0899 7.35582C35.8976 5.54806 38.8364 5.54806 40.6442 7.35582C42.4519 9.16358 42.4519 12.1024 40.6442 13.9101"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Erase({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M27.6233 40.7549H21.7953M11.5563 40.7549H4M25.3953 36.8273L21.7953 40.7426M16.5079 27.9521L11.4458 33.4648C11.2452 33.6824 11.0894 33.9375 10.9874 34.2153C10.8854 34.4932 10.8392 34.7884 10.8514 35.0841C10.8636 35.3798 10.9339 35.6703 11.0584 35.9388C11.1828 36.2073 11.359 36.4487 11.5768 36.6491L15.4062 40.1652C15.8204 40.5468 16.3625 40.7594 16.9256 40.7611H21.7728M16.5079 27.9521L34.168 8.72955C34.3682 8.51147 34.6093 8.33496 34.8777 8.21013C35.1461 8.08529 35.4364 8.01458 35.7322 8.00203C36.0279 7.98947 36.3232 8.03533 36.6012 8.13697C36.8792 8.23862 37.1344 8.39406 37.3523 8.5944L43.2704 14.0456C43.4885 14.2457 43.665 14.4869 43.7899 14.7553C43.9147 15.0237 43.9854 15.314 43.998 15.6098C44.0105 15.9055 43.9647 16.2008 43.863 16.4788C43.7614 16.7568 43.6059 17.012 43.4056 17.2299L25.3953 36.8232M16.5079 27.9521L25.383 36.8273"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function FilterEnabled({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M6 10.8013H24.7191"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M6 24.0759H11.2783"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.2792 28.8772C19.9309 28.8772 22.0805 26.7276 22.0805 24.0759C22.0805 21.4243 19.9309 19.2747 17.2792 19.2747C14.6275 19.2747 12.4779 21.4243 12.4779 24.0759C12.4779 26.7276 14.6275 28.8772 17.2792 28.8772Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M23.2809 24.0754H42"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M6 37.2061H27.3605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M33.3605 42.0071C36.0122 42.0071 38.1618 39.8575 38.1618 37.2058C38.1618 34.5541 36.0122 32.4045 33.3605 32.4045C30.7089 32.4045 28.5593 34.5541 28.5593 37.2058C28.5593 39.8575 30.7089 42.0071 33.3605 42.0071Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M39.3583 37.2053H41.9997"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        className="special-color"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38 18C42.4183 18 46 14.4183 46 10C46 5.58172 42.4183 2 38 2C33.5817 2 30 5.58172 30 10C30 14.4183 33.5817 18 38 18Z"
        fill="#FF9533"
      />
    </SvgIconComponent>
  )
}

export function FilterDisabled({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M6 10.8013H24.7191"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M30.7155 15.6026C33.3672 15.6026 35.5168 13.453 35.5168 10.8013C35.5168 8.14961 33.3672 6 30.7155 6C28.0639 6 25.9142 8.14961 25.9142 10.8013C25.9142 13.453 28.0639 15.6026 30.7155 15.6026Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M36.7211 10.8008H41.9993"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M6 24.0762H11.2783"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.2792 28.8775C19.9309 28.8775 22.0805 26.7279 22.0805 24.0762C22.0805 21.4245 19.9309 19.2749 17.2792 19.2749C14.6275 19.2749 12.4779 21.4245 12.4779 24.0762C12.4779 26.7279 14.6275 28.8775 17.2792 28.8775Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M23.2809 24.0757H42"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M6 37.2061H27.3605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M33.3605 42.0073C36.0122 42.0073 38.1618 39.8577 38.1618 37.2061C38.1618 34.5544 36.0122 32.4048 33.3605 32.4048C30.7089 32.4048 28.5593 34.5544 28.5593 37.2061C28.5593 39.8577 30.7089 42.0073 33.3605 42.0073Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M39.3583 37.2056H41.9997"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function Info({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 34.8726H24.25H28"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 21.5H25.25V34.0508"
        stroke={stroke}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.625 14.3125C25.625 15.3135 24.8135 16.125 23.8125 16.125C22.8115 16.125 22 15.3135 22 14.3125C22 13.3115 22.8115 12.5 23.8125 12.5C24.8135 12.5 25.625 13.3115 25.625 14.3125Z"
        fill={stroke}
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function PinChangePosition({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M12.876 30.874L6 23.992L12.874 17.116"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.875 35.126L24.001 42L17.375 35.37"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.375 17.374L42.005 23.998L35.375 30.628"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.375 12.624L24.001 6L30.877 12.874"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0039 6V42"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.0039 24H6.00391"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function PinCopy({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M31.3628 16.3169C28.8881 16.2365 26.4825 17.141 24.6738 18.832C22.8651 20.523 21.8009 22.8624 21.7148 25.3369C21.7148 31.8549 31.3628 44.005 31.3628 44.005C31.3628 44.005 41.0108 31.8549 41.0108 25.3369C40.9248 22.8624 39.8606 20.523 38.0519 18.832C36.2432 17.141 33.8376 16.2365 31.3628 16.3169Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.154 11.4869C26.6878 9.32848 25.4833 7.40023 23.7481 6.03447C22.0128 4.66871 19.8556 3.95097 17.648 4.00494C15.1732 3.92452 12.7676 4.82902 10.9589 6.52001C9.15021 8.21099 8.08608 10.5504 8 13.0249C8 19.5429 17.648 31.6929 17.648 31.6929C17.648 31.6929 18.13 31.0929 18.874 30.0749"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Reactivate({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M7.47852 17.0807C10.7771 9.16003 19.2081 4.66905 27.6216 6.35097C36.0352 8.03287 42.0918 15.42 42.0918 24C42.0918 32.58 36.0352 39.9671 27.6216 41.649C19.2081 43.3309 10.7771 38.84 7.47852 30.9193"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.40039 9.57129L6.89301 17.0225C6.9364 17.2391 7.14716 17.3795 7.36374 17.3361L14.815 15.8435"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ReviseRedo({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M26.999 42H19.499C15.9161 42.008 12.4776 40.5882 9.94415 38.0548C7.41065 35.5213 5.99091 32.0829 5.99889 28.5M5.99889 28.5V28.5ZM5.99889 28.5C5.99091 24.9172 7.41068 21.4787 9.94415 18.9453C12.4776 16.4118 15.9161 14.992 19.499 15H41.699"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0008 6L41.5808 14.58C41.6985 14.6879 41.7654 14.8403 41.7654 15C41.7654 15.1597 41.6985 15.312 41.5808 15.42L33.0008 24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ReviseUndo({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M20.7637 42H28.2637C31.8465 42.008 35.2849 40.5882 37.8184 38.0548C40.3519 35.5213 41.7716 32.0829 41.7636 28.5M41.7636 28.5V28.5ZM41.7636 28.5C41.7716 24.9172 40.3519 21.4787 37.8184 18.9453C35.2849 16.4118 31.8465 14.992 28.2637 15L6.06373 15"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7637 6L6.18376 14.58C6.06611 14.6879 5.99912 14.8403 5.99912 15C5.99912 15.1597 6.06611 15.312 6.18376 15.42L14.7637 24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function RotateCounterclockwise({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 26.3721C8 24.1629 9.79086 22.3721 12 22.3721H25.628C27.8371 22.3721 29.628 24.1629 29.628 26.3721V40.0001C29.628 42.2092 27.8371 44.0001 25.628 44.0001H12C9.79086 44.0001 8 42.2092 8 40.0001V26.3721Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9335 4L18.8164 10.1172L24.9335 16.2342"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4082 10.1177H28.1889C28.1889 10.1177 39.5063 9.99565 39.7236 21.6527C39.7767 24.5086 39.8274 29.6073 39.817 29.6003"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function RotateClockwise({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1914 26.3721C18.1914 24.1629 19.9823 22.3721 22.1914 22.3721H35.8194C38.0285 22.3721 39.8194 24.1629 39.8194 26.3721V40.0001C39.8194 42.2092 38.0285 44.0001 35.8194 44.0001H22.1914C19.9823 44.0001 18.1914 42.2092 18.1914 40.0001V26.3721Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8828 4L28.9999 10.1172L22.8828 16.2342"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4102 10.1177H19.6294C19.6294 10.1177 8.31264 9.99565 8.09474 21.6527C8.04164 24.5086 7.99099 29.6073 8.00136 29.6003"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}
export function Send({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5553 24L6 42L15.5893 24L6 6L41.5553 24Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M15.2734 24H40.5174M40.5174 24V24Z"
        stroke="#141A21"
        strokeWidth={2}
      />
    </SvgIconComponent>
  )
}

export function Settings({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.8417 10.8136L21.6267 11.2651L21.6275 11.2654L21.8417 10.8136ZM19.1789 9.54589L19.3938 9.09444L19.3931 9.09412L19.1789 9.54589ZM19.0417 9.40139L19.5039 9.21083L19.5036 9.20999L19.0417 9.40139ZM18.8167 8.85832L19.2786 8.66693L19.2782 8.6659L18.8167 8.85832ZM18.8114 8.65914L18.3402 8.49185L18.3398 8.49307L18.8114 8.65914ZM19.7981 5.88001L20.2692 6.0473L20.2693 6.04709L19.7981 5.88001ZM19.7328 5.59054L19.3792 5.9441L19.3793 5.94418L19.7328 5.59054ZM18.4095 4.26725L18.0558 4.62068L18.0559 4.6208L18.4095 4.26725ZM18.12 4.20195L17.9528 3.73071L17.9527 3.73076L18.12 4.20195ZM15.3409 5.18863L15.5068 5.66028L15.5082 5.65981L15.3409 5.18863ZM15.1417 5.18334L15.334 4.72179L15.3331 4.72143L15.1417 5.18334ZM14.5986 4.95833L14.79 4.49641L14.7892 4.49606L14.5986 4.95833ZM14.4541 4.82115L14.9059 4.60693L14.9056 4.60621L14.4541 4.82115ZM13.1864 2.15833L12.7346 2.37251L12.7349 2.37326L13.1864 2.15833ZM10.8136 2.15833L11.2651 2.37326L11.2654 2.37251L10.8136 2.15833ZM9.54588 4.82115L9.09443 4.60621L9.09412 4.60688L9.54588 4.82115ZM9.40138 4.95833L9.21083 4.49606L9.20999 4.49641L9.40138 4.95833ZM8.85832 5.18334L8.66692 4.72143L8.6659 4.72185L8.85832 5.18334ZM8.65913 5.18863L8.49185 5.65981L8.49307 5.66024L8.65913 5.18863ZM5.88001 4.20195L6.04729 3.73076L6.04709 3.73069L5.88001 4.20195ZM5.59054 4.26725L5.94409 4.6208L5.94417 4.62072L5.59054 4.26725ZM4.26724 5.59054L4.62068 5.94421L4.6208 5.9441L4.26724 5.59054ZM4.20194 5.88001L3.73071 6.04716L3.73076 6.0473L4.20194 5.88001ZM5.18863 8.65914L5.66028 8.49318L5.65981 8.49185L5.18863 8.65914ZM5.18334 8.85832L4.72179 8.66605L4.72142 8.66693L5.18334 8.85832ZM4.95833 9.40139L4.49641 9.20999L4.49606 9.21083L4.95833 9.40139ZM4.82114 9.54589L4.60693 9.0941L4.60621 9.09444L4.82114 9.54589ZM2.15833 10.8136L2.37251 11.2654L2.37326 11.2651L2.15833 10.8136ZM2.15833 13.1864L2.37326 12.7349L2.37245 12.7345L2.15833 13.1864ZM4.82114 14.4541L4.60621 14.9056L4.60688 14.9059L4.82114 14.4541ZM4.95833 14.5986L4.49572 14.7884L4.49641 14.79L4.95833 14.5986ZM5.18334 15.1417L4.72142 15.3331L4.72185 15.3341L5.18334 15.1417ZM5.18863 15.3409L5.65981 15.5081L5.66024 15.5069L5.18863 15.3409ZM4.20194 18.12L3.73076 17.9527L3.73069 17.9529L4.20194 18.12ZM4.26724 18.4095L4.6208 18.0559L4.62072 18.0558L4.26724 18.4095ZM5.59054 19.7328L5.23699 20.0863L5.23757 20.0869L5.59054 19.7328ZM5.88001 19.7981L6.04716 20.2693L6.04729 20.2692L5.88001 19.7981ZM8.65913 18.8114L8.49317 18.3397L8.49185 18.3402L8.65913 18.8114ZM8.85832 18.8167L8.66604 19.2782L8.66692 19.2786L8.85832 18.8167ZM9.40138 19.0417L9.20999 19.5036L9.21083 19.5039L9.40138 19.0417ZM9.54588 19.1789L9.09409 19.3931L9.09443 19.3938L9.54588 19.1789ZM10.8136 21.8417L11.2654 21.6275L11.2651 21.6267L10.8136 21.8417ZM13.1864 21.8417L12.7349 21.6267L12.7346 21.6275L13.1864 21.8417ZM14.4541 19.1789L14.9056 19.3938L14.9059 19.3931L14.4541 19.1789ZM14.5986 19.0417L14.7892 19.5039L14.79 19.5036L14.5986 19.0417ZM15.1417 18.8167L15.3331 19.2786L15.3341 19.2781L15.1417 18.8167ZM15.3409 18.8114L15.5082 18.3402L15.5069 18.3398L15.3409 18.8114ZM18.12 19.7981L17.9527 20.2692L17.9529 20.2693L18.12 19.7981ZM18.4095 19.7328L18.7624 20.087L18.763 20.0863L18.4095 19.7328ZM19.7328 18.4095L19.3793 18.0558L19.3792 18.0559L19.7328 18.4095ZM19.7981 18.12L20.2693 17.9528L20.2692 17.9527L19.7981 18.12ZM18.8114 15.3409L18.3397 15.5068L18.3402 15.5081L18.8114 15.3409ZM18.8167 15.1417L19.2782 15.334L19.2786 15.3331L18.8167 15.1417ZM19.0417 14.5986L19.5036 14.79L19.5043 14.7884L19.0417 14.5986ZM19.1789 14.4541L19.3931 14.9059L19.3938 14.9056L19.1789 14.4541ZM21.8417 13.1864L21.6275 12.7346L21.6267 12.7349L21.8417 13.1864ZM21.8417 10.8136L22.0566 10.3622L19.3938 9.09444L19.1789 9.54589L18.9639 9.99733L21.6267 11.2651L21.8417 10.8136ZM19.1789 9.54589L19.3931 9.09412C19.4435 9.11802 19.4828 9.15965 19.5039 9.21083L19.0417 9.40139L18.5794 9.59194C18.6527 9.76976 18.7898 9.91475 18.9646 9.99765L19.1789 9.54589ZM19.0417 9.40139L19.5036 9.20999L19.2786 8.66693L18.8167 8.85832L18.3547 9.04971L18.5798 9.59278L19.0417 9.40139ZM18.8167 8.85832L19.2782 8.6659C19.3 8.71834 19.3007 8.77499 19.283 8.82521L18.8114 8.65914L18.3398 8.49307C18.2765 8.67279 18.2805 8.87167 18.3552 9.05074L18.8167 8.85832ZM18.8114 8.65914L19.2826 8.82643L20.2692 6.0473L19.7981 5.88001L19.3269 5.71272L18.3402 8.49185L18.8114 8.65914ZM19.7981 5.88001L20.2693 6.04709C20.3694 5.76484 20.299 5.44957 20.0862 5.23691L19.7328 5.59054L19.3793 5.94418C19.3183 5.88322 19.2984 5.79295 19.3268 5.71293L19.7981 5.88001ZM19.7328 5.59054L20.0863 5.23699L18.763 3.91369L18.4095 4.26725L18.0559 4.6208L19.3792 5.9441L19.7328 5.59054ZM18.4095 4.26725L18.7631 3.91381C18.5505 3.70104 18.2352 3.63057 17.9528 3.73071L18.12 4.20195L18.2871 4.67318C18.2071 4.70159 18.1168 4.68168 18.0558 4.62068L18.4095 4.26725ZM18.12 4.20195L17.9527 3.73076L15.1736 4.71744L15.3409 5.18863L15.5082 5.65981L18.2873 4.67313L18.12 4.20195ZM15.3409 5.18863L15.1749 4.71697C15.2251 4.69932 15.2816 4.7 15.334 4.72179L15.1417 5.18334L14.9494 5.6449C15.1284 5.71946 15.3272 5.7235 15.5068 5.66028L15.3409 5.18863ZM15.1417 5.18334L15.3331 4.72143L14.79 4.49641L14.5986 4.95833L14.4072 5.42025L14.9503 5.64526L15.1417 5.18334ZM14.5986 4.95833L14.7892 4.49606C14.8403 4.51715 14.882 4.55647 14.9059 4.60693L14.4541 4.82115L14.0023 5.03536C14.0853 5.21025 14.2303 5.34731 14.4081 5.42059L14.5986 4.95833ZM14.4541 4.82115L14.9056 4.60621L13.6378 1.9434L13.1864 2.15833L12.7349 2.37326L14.0027 5.03608L14.4541 4.82115ZM13.1864 2.15833L13.6382 1.94415C13.5093 1.6724 13.2354 1.5 12.9358 1.5V2V2.5C12.8502 2.5 12.7717 2.4509 12.7346 2.37251L13.1864 2.15833ZM12.9358 2V1.5H11.0642V2V2.5H12.9358V2ZM11.0642 2V1.5C10.7646 1.5 10.4907 1.6724 10.3618 1.94415L10.8136 2.15833L11.2654 2.37251C11.2283 2.4509 11.1498 2.5 11.0642 2.5V2ZM10.8136 2.15833L10.3622 1.9434L9.09443 4.60621L9.54588 4.82115L9.99733 5.03608L11.2651 2.37326L10.8136 2.15833ZM9.54588 4.82115L9.09412 4.60688C9.11802 4.55649 9.15964 4.51716 9.21083 4.49606L9.40138 4.95833L9.59193 5.42059C9.76976 5.34729 9.91475 5.2102 9.99765 5.03541L9.54588 4.82115ZM9.40138 4.95833L9.20999 4.49641L8.66692 4.72143L8.85832 5.18334L9.04971 5.64526L9.59277 5.42025L9.40138 4.95833ZM8.85832 5.18334L8.6659 4.72185C8.71833 4.69999 8.77498 4.69933 8.8252 4.71701L8.65913 5.18863L8.49307 5.66024C8.67279 5.72353 8.87167 5.7195 9.05074 5.64484L8.85832 5.18334ZM8.65913 5.18863L8.82642 4.71744L6.04729 3.73076L5.88001 4.20195L5.71272 4.67313L8.49185 5.65981L8.65913 5.18863ZM5.88001 4.20195L6.04709 3.73069C5.76484 3.63062 5.44956 3.70102 5.23691 3.91377L5.59054 4.26725L5.94417 4.62072C5.88322 4.6817 5.79294 4.70157 5.71293 4.6732L5.88001 4.20195ZM5.59054 4.26725L5.23699 3.91369L3.91369 5.23699L4.26724 5.59054L4.6208 5.9441L5.94409 4.6208L5.59054 4.26725ZM4.26724 5.59054L3.91381 5.23687C3.70104 5.4495 3.63057 5.76484 3.73071 6.04716L4.20194 5.88001L4.67318 5.71286C4.70159 5.79295 4.68168 5.88325 4.62068 5.94421L4.26724 5.59054ZM4.20194 5.88001L3.73076 6.0473L4.71744 8.82643L5.18863 8.65914L5.65981 8.49185L4.67313 5.71272L4.20194 5.88001ZM5.18863 8.65914L4.71697 8.8251C4.69932 8.77493 4.69999 8.71837 4.72179 8.66605L5.18334 8.85832L5.6449 9.05059C5.71946 8.87161 5.7235 8.67285 5.66028 8.49318L5.18863 8.65914ZM5.18334 8.85832L4.72142 8.66693L4.49641 9.20999L4.95833 9.40139L5.42024 9.59278L5.64526 9.04971L5.18334 8.85832ZM4.95833 9.40139L4.49606 9.21083C4.51714 9.15969 4.55647 9.11803 4.60693 9.0941L4.82114 9.54589L5.03536 9.99768C5.21025 9.91475 5.34731 9.76972 5.42059 9.59194L4.95833 9.40139ZM4.82114 9.54589L4.60621 9.09444L1.9434 10.3622L2.15833 10.8136L2.37326 11.2651L5.03607 9.99733L4.82114 9.54589ZM2.15833 10.8136L1.94415 10.3618C1.6724 10.4907 1.5 10.7646 1.5 11.0642H2H2.5C2.5 11.1498 2.4509 11.2283 2.37251 11.2654L2.15833 10.8136ZM2 11.0642H1.5V12.9356H2H2.5V11.0642H2ZM2 12.9356H1.5C1.5 13.2351 1.67213 13.5093 1.94422 13.6382L2.15833 13.1864L2.37245 12.7345C2.45117 12.7718 2.5 12.8505 2.5 12.9356H2ZM2.15833 13.1864L1.9434 13.6378L4.60621 14.9056L4.82114 14.4541L5.03607 14.0027L2.37326 12.7349L2.15833 13.1864ZM4.82114 14.4541L4.60688 14.9059C4.55731 14.8824 4.5172 14.8407 4.49573 14.7884L4.95833 14.5986L5.42093 14.4089C5.34725 14.2293 5.20938 14.0849 5.0354 14.0023L4.82114 14.4541ZM4.95833 14.5986L4.49641 14.79L4.72142 15.3331L5.18334 15.1417L5.64526 14.9503L5.42024 14.4072L4.95833 14.5986ZM5.18334 15.1417L4.72185 15.3341C4.69999 15.2817 4.69933 15.225 4.71701 15.1748L5.18863 15.3409L5.66024 15.5069C5.72353 15.3272 5.7195 15.1283 5.64483 14.9493L5.18334 15.1417ZM5.18863 15.3409L4.71744 15.1736L3.73076 17.9527L4.20194 18.12L4.67313 18.2873L5.65981 15.5081L5.18863 15.3409ZM4.20194 18.12L3.73069 17.9529C3.63062 18.2352 3.70102 18.5504 3.91377 18.7631L4.26724 18.4095L4.62072 18.0558C4.6817 18.1168 4.70157 18.2071 4.6732 18.2871L4.20194 18.12ZM4.26724 18.4095L3.91369 18.763L5.23699 20.0863L5.59054 19.7328L5.94409 19.3792L4.6208 18.0559L4.26724 18.4095ZM5.59054 19.7328L5.23757 20.0869C5.44927 20.2979 5.76391 20.3698 6.04716 20.2693L5.88001 19.7981L5.71286 19.3268C5.79387 19.2981 5.88348 19.3188 5.94351 19.3786L5.59054 19.7328ZM5.88001 19.7981L6.04729 20.2692L8.82642 19.2826L8.65913 18.8114L8.49185 18.3402L5.71272 19.3269L5.88001 19.7981ZM8.65913 18.8114L8.82509 19.283C8.77492 19.3007 8.71836 19.3 8.66604 19.2782L8.85832 18.8167L9.05059 18.3551C8.87161 18.2805 8.67285 18.2765 8.49317 18.3397L8.65913 18.8114ZM8.85832 18.8167L8.66692 19.2786L9.20999 19.5036L9.40138 19.0417L9.59278 18.5798L9.04971 18.3547L8.85832 18.8167ZM9.40138 19.0417L9.21083 19.5039C9.15969 19.4829 9.11802 19.4435 9.09409 19.3931L9.54588 19.1789L9.99767 18.9646C9.91474 18.7897 9.76971 18.6527 9.59193 18.5794L9.40138 19.0417ZM9.54588 19.1789L9.09443 19.3938L10.3622 22.0566L10.8136 21.8417L11.2651 21.6267L9.99733 18.9639L9.54588 19.1789ZM10.8136 21.8417L10.3618 22.0558C10.4907 22.3276 10.7646 22.5 11.0642 22.5V22V21.5C11.1498 21.5 11.2283 21.5491 11.2654 21.6275L10.8136 21.8417ZM11.0642 22V22.5H12.9358V22V21.5H11.0642V22ZM12.9358 22V22.5C13.2354 22.5 13.5094 22.3276 13.6382 22.0558L13.1864 21.8417L12.7346 21.6275C12.7717 21.5491 12.8502 21.5 12.9358 21.5V22ZM13.1864 21.8417L13.6378 22.0566L14.9056 19.3938L14.4541 19.1789L14.0027 18.9639L12.7349 21.6267L13.1864 21.8417ZM14.4541 19.1789L14.9059 19.3931C14.882 19.4435 14.8404 19.4828 14.7892 19.5039L14.5986 19.0417L14.4081 18.5794C14.2302 18.6527 14.0853 18.7898 14.0024 18.9646L14.4541 19.1789ZM14.5986 19.0417L14.79 19.5036L15.3331 19.2786L15.1417 18.8167L14.9503 18.3547L14.4072 18.5798L14.5986 19.0417ZM15.1417 18.8167L15.3341 19.2781C15.2817 19.3 15.225 19.3007 15.1748 19.283L15.3409 18.8114L15.5069 18.3398C15.3272 18.2765 15.1283 18.2805 14.9493 18.3552L15.1417 18.8167ZM15.3409 18.8114L15.1736 19.2826L17.9527 20.2692L18.12 19.7981L18.2873 19.3269L15.5082 18.3402L15.3409 18.8114ZM18.12 19.7981L17.9529 20.2693C18.2361 20.3697 18.5507 20.2978 18.7624 20.087L18.4095 19.7328L18.0566 19.3785C18.1165 19.3188 18.2061 19.2981 18.2871 19.3268L18.12 19.7981ZM18.4095 19.7328L18.763 20.0863L20.0863 18.763L19.7328 18.4095L19.3792 18.0559L18.0559 19.3792L18.4095 19.7328ZM19.7328 18.4095L20.0862 18.7631C20.299 18.5505 20.3694 18.2352 20.2693 17.9528L19.7981 18.12L19.3268 18.2871C19.2984 18.2071 19.3183 18.1167 19.3793 18.0558L19.7328 18.4095ZM19.7981 18.12L20.2692 17.9527L19.2826 15.1736L18.8114 15.3409L18.3402 15.5081L19.3269 18.2873L19.7981 18.12ZM18.8114 15.3409L19.283 15.1749C19.3007 15.2251 19.3 15.2816 19.2782 15.334L18.8167 15.1417L18.3551 14.9494C18.2805 15.1284 18.2765 15.3271 18.3397 15.5068L18.8114 15.3409ZM18.8167 15.1417L19.2786 15.3331L19.5036 14.79L19.0417 14.5986L18.5798 14.4072L18.3547 14.9503L18.8167 15.1417ZM19.0417 14.5986L19.5043 14.7884C19.4828 14.8407 19.4427 14.8824 19.3931 14.9059L19.1789 14.4541L18.9646 14.0023C18.7906 14.0849 18.6527 14.2293 18.5791 14.4089L19.0417 14.5986ZM19.1789 14.4541L19.3938 14.9056L22.0566 13.6378L21.8417 13.1864L21.6267 12.7349L18.9639 14.0027L19.1789 14.4541ZM21.8417 13.1864L22.0558 13.6382C22.3278 13.5092 22.5 13.2351 22.5 12.9356H22H21.5C21.5 12.8505 21.5489 12.7718 21.6275 12.7346L21.8417 13.1864ZM22 12.9356H22.5V11.0642H22H21.5V12.9356H22ZM22 11.0642H22.5C22.5 10.7646 22.3276 10.4907 22.0558 10.3618L21.8417 10.8136L21.6275 11.2654C21.5491 11.2283 21.5 11.1498 21.5 11.0642H22ZM11.9993 15.3332V14.8332C10.4347 14.8332 9.16602 13.5645 9.16602 11.9998H8.66602H8.16602C8.16602 14.1168 9.88239 15.8332 11.9993 15.8332V15.3332ZM8.66602 11.9998H9.16602C9.16602 10.4352 10.4347 9.1665 11.9993 9.1665V8.6665V8.1665C9.88239 8.1665 8.16602 9.88288 8.16602 11.9998H8.66602ZM11.9993 8.6665V9.1665C13.564 9.1665 14.8327 10.4352 14.8327 11.9998H15.3327H15.8327C15.8327 9.88288 14.1163 8.1665 11.9993 8.1665V8.6665ZM15.3327 11.9998H14.8327C14.8327 13.5645 13.564 14.8332 11.9993 14.8332V15.3332V15.8332C14.1163 15.8332 15.8327 14.1168 15.8327 11.9998H15.3327Z"
        stroke={stroke}
        strokeWidth="0.5"
      />
    </SvgIconComponent>
  )
}

export function Share({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M41.999 19.4999V8.24993C41.9989 7.65324 41.7618 7.08104 41.3398 6.65918"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 6H10.5C9.30653 6 8.162 6.4741 7.31808 7.31802C6.47417 8.16193 6 9.30653 6 10.5V37.5C6 38.6935 6.47417 39.8381 7.31808 40.682C8.162 41.5259 9.30653 42 10.5 42H37.5C38.6935 42 39.838 41.5259 40.6819 40.682C41.5258 39.8381 42 38.6935 42 37.5V28.5"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3408 6.65925C40.919 6.23726 40.3467 6.00013 39.75 6H28.5"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 23.9999L41.3407 6.65918"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Sort({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M16 20.0478L23.9813 28.3095L32 20"
        stroke="#141A21"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Sortation({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M37.4121 17.9995C37.4121 17.4472 36.9644 16.9995 36.4121 16.9995C35.8598 16.9995 35.4121 17.4472 35.4121 17.9995H37.4121ZM35.4121 42.7022C35.4121 43.2545 35.8598 43.7022 36.4121 43.7022C36.9644 43.7022 37.4121 43.2545 37.4121 42.7022H35.4121ZM29.5274 34.4072C29.1369 34.0167 28.5037 34.0167 28.1132 34.4072C27.7227 34.7977 27.7227 35.4309 28.1132 35.8214L29.5274 34.4072ZM36.4082 42.7022L35.7011 43.4093C36.0915 43.7997 36.7245 43.7998 37.1151 43.4095L36.4082 42.7022ZM44.7077 35.8216C45.0984 35.4312 45.0986 34.7981 44.7082 34.4074C44.3178 34.0168 43.6846 34.0166 43.294 34.407L44.7077 35.8216ZM35.4121 17.9995V42.7022H37.4121V17.9995H35.4121ZM28.1132 35.8214L35.7011 43.4093L37.1153 41.9951L29.5274 34.4072L28.1132 35.8214ZM37.1151 43.4095L44.7077 35.8216L43.294 34.407L35.7013 41.9949L37.1151 43.4095Z"
        fill="#141A21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0343 17.9993H4H30.0343Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.934 37.998H4H22.934Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0343 27.9988H4H30.0343Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.4989 8H4H36.4989Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Viewlist({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10H44H4Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 20H44"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 30H44H4Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 40H44H4Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ViewSplit({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M9 21H18"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M9.00006 27.6646H18.0001"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M9.00006 34.3291H18.0001"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M43.9777 36.457V36.467"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.9749 36.4566V11.7119C43.9749 10.9618 43.8272 10.219 43.5402 9.526C43.2531 8.83301 42.8326 8.20341 42.3022 7.67302C41.7718 7.14262 41.1419 6.7218 40.4489 6.43475C39.7559 6.1477 39.0134 6 38.2633 6V30.7538C39.7766 30.7538 41.2279 31.3543 42.2989 32.4235C43.3698 33.4927 43.9725 34.9432 43.9749 36.4566Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8517 13.6165H38.2117"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 13.6165V42.1804"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
        strokeDasharray="9 4.5"
      />
      <path
        d="M43.98 36.4497C43.98 37.2001 43.8321 37.9431 43.545 38.6364C43.2578 39.3297 42.837 39.9596 42.3064 40.4902C41.7758 41.0208 41.1459 41.4417 40.4526 41.7289C39.7593 42.0161 39.0163 42.1638 38.2659 42.1638H25.8517"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8493 13.6157H3.98999V42.1797H25.8493"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9724 32.2025C39.6526 33.4236 38.9371 34.5044 37.9381 35.276C36.9391 36.0476 35.7127 36.4664 34.4505 36.4672H29.6136V19.3293H37.8423"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ViewTale({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8C6 6.89543 6.89543 6 8 6H19.75C20.8546 6 21.75 6.89543 21.75 8V19.75C21.75 20.8546 20.8546 21.75 19.75 21.75H8C6.89543 21.75 6 20.8546 6 19.75V8Z"
        stroke={stroke}
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.25 8C26.25 6.89543 27.1454 6 28.25 6H40C41.1046 6 42 6.89543 42 8V19.75C42 20.8546 41.1046 21.75 40 21.75H28.25C27.1454 21.75 26.25 20.8546 26.25 19.75V8Z"
        stroke={stroke}
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.25 28.25C26.25 27.1454 27.1454 26.25 28.25 26.25H40C41.1046 26.25 42 27.1454 42 28.25V40C42 41.1046 41.1046 42 40 42H28.25C27.1454 42 26.25 41.1046 26.25 40V28.25Z"
        stroke={stroke}
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 28.25C6 27.1454 6.89543 26.25 8 26.25H19.75C20.8546 26.25 21.75 27.1454 21.75 28.25V40C21.75 41.1046 20.8546 42 19.75 42H8C6.89543 42 6 41.1046 6 40V28.25Z"
        stroke={stroke}
        strokeWidth={2}
      />
    </SvgIconComponent>
  )
}

export function Search({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      stroke={stroke}
      size={size}
    >
      <path
        d="M10.0171 17.0342C13.8925 17.0342 17.0342 13.8925 17.0342 10.0171C17.0342 6.14166 13.8925 3 10.0171 3C6.14166 3 3 6.14166 3 10.0171C3 13.8925 6.14166 17.0342 10.0171 17.0342Z"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
      />
      <path
        d="M20.999 21.0009L15.2783 15.2803L20.999 21.0009Z"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
      />
    </SvgIconComponent>
  )
}

export function NotFound({ size, ...props }) {
  return (
    <SvgIconComponent
      height="48"
      width="52"
      fill="none"
      viewBox="0 0 52 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M47.2469 16.713C46.6912 14.756 46.056 12.7932 45.4412 10.8952C44.8304 9.00897 44.199 7.05834 43.6506 5.12624C43.5828 4.88667 43.4023 4.25093 42.7689 4.05187C42.4196 3.94258 42.1001 4.03236 41.9278 4.08164L37.4118 5.3453L38.1514 7.6931C33.9359 8.88018 25.7748 11.2621 25.6879 11.288L24.9682 11.4978L25.1951 12.2121C25.2132 12.2687 25.2317 12.3272 25.2508 12.3872C21.9296 13.3167 15.7932 15.0497 15.7932 15.0497L15.0658 15.2551L15.2946 15.9758L15.2995 15.9904L8.75083 17.8478L8.39952 16.6027L7.70232 16.7891C7.01096 16.974 5.38818 17.4526 5.38818 17.4526L4.68951 17.6585L4.89151 18.3577C5.517 20.5211 6.9685 25.5894 6.9685 25.5894L7.17781 26.3188L10.7951 25.1401L10.538 24.2228L17.2125 22.4649C17.2321 22.5317 17.2428 22.5703 17.2438 22.5737L17.4545 23.3099L18.1801 23.0665C19.2466 22.7093 20.3244 22.3697 21.4056 22.0389C21.048 22.6879 20.844 23.4236 20.844 24.196C20.844 25.1074 21.1255 25.9734 21.6149 26.6994C18.9851 32.1581 16.0957 37.5596 13.0146 42.7607L14.2744 43.5072C17.2857 38.4223 20.1116 33.1456 22.698 27.8128C22.9439 27.9919 23.2025 28.1548 23.4865 28.2822C23.8539 28.449 24.2398 28.5578 24.637 28.6188C24.9141 31.5589 25.04 34.3571 25.1673 37.3055C25.2303 38.7526 25.2927 40.2119 25.3757 41.702L26.8374 41.62C26.755 40.1363 26.692 38.6838 26.6296 37.2425C26.5032 34.3156 26.3768 31.534 26.1046 28.6042C26.7755 28.4851 27.3936 28.2173 27.9264 27.8343L39.0823 44L40.287 43.1691L28.9759 26.7784C29.4936 26.0476 29.8009 25.1576 29.8009 24.196C29.8009 23.0362 29.354 21.9814 28.6285 21.1851L28.6602 21.1744C32.7845 19.7926 37.0151 18.5577 41.2413 17.5019L41.8727 19.5062L42.5626 19.3018C42.5631 19.3013 45.4715 18.4387 46.3468 18.1904C46.8615 18.0445 47.1752 17.7674 47.2787 17.3663C47.3504 17.0853 47.2835 16.8452 47.2469 16.713V16.713ZM8.16679 24.457C7.79552 23.1611 7.01193 20.4279 6.50012 18.6519C6.77188 18.5729 7.08951 18.4811 7.38469 18.3972L9.00746 24.1833L8.16679 24.457ZM10.1433 22.8137L9.14703 19.2569L15.7293 17.3896C16.086 18.5772 16.5017 20.0024 16.8071 21.0577L10.1433 22.8137ZM16.9144 16.2543C18.6426 15.7664 23.062 14.5198 25.6826 13.7865C26.1792 15.419 26.7813 17.4594 27.2024 18.8963C24.2637 19.6384 21.3226 20.4918 18.4406 21.4383C18.0961 20.2424 17.4023 17.8478 16.9144 16.2543H16.9144ZM25.3225 27.2131C24.8907 27.2131 24.477 27.1243 24.0886 26.9477C23.0069 26.4642 22.3077 25.384 22.3077 24.1959C22.3077 23.0698 22.9283 22.0462 23.93 21.5222C24.352 21.2992 24.8336 21.1812 25.3225 21.1812C26.9848 21.1812 28.3372 22.5331 28.3372 24.1959C28.3372 25.8597 26.9848 27.2131 25.3225 27.2131ZM27.5532 20.4255C27.6806 20.3871 27.8078 20.3409 27.9351 20.3025L28.0532 20.8025C27.8884 20.6794 27.7239 20.5486 27.5532 20.4255H27.5532ZM28.9179 19.5462C28.4832 18.0557 27.4771 14.6243 26.8145 12.4838C28.9149 11.872 35.1255 10.0658 38.591 9.08997L40.8007 16.1036C36.8126 17.1018 32.8211 18.2582 28.9179 19.5462L28.9179 19.5462Z"
        fill="#A0A0AA"
        fillRule="evenodd"
      />
    </SvgIconComponent>
  )
}

export function EmptyState({ size, ...props }) {
  return (
    <SvgIconComponent
      height="136"
      width="144"
      fill="none"
      viewBox="0 0 144 136"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M121.893 111.303L122.413 113.748C123.061 113.61 123.628 113.22 123.989 112.664C124.351 112.108 124.476 111.431 124.338 110.783L121.893 111.303ZM45.3496 127.572L42.9043 128.092C43.1913 129.443 44.5189 130.305 45.8694 130.018L45.3496 127.572ZM22.1072 18.2252L21.5874 15.7798C20.9388 15.9177 20.3716 16.3075 20.0105 16.8636C19.6494 17.4197 19.524 18.0964 19.6618 18.745L22.1072 18.2252ZM72.2247 7.57239L73.5302 5.44031C72.9843 5.10607 72.331 4.99394 71.7049 5.12702L72.2247 7.57239ZM103.977 27.0142L104.496 29.4596C105.497 29.2468 106.268 28.4456 106.441 27.4371C106.614 26.4286 106.155 25.4164 105.282 24.8821L103.977 27.0142ZM77.5511 32.6311L75.1057 33.1509C75.3928 34.5014 76.7203 35.3636 78.0709 35.0765L77.5511 32.6311ZM109.167 39.4064C108.88 38.0559 107.552 37.1938 106.201 37.4808C104.851 37.7679 103.989 39.0954 104.276 40.446L106.721 39.9262L109.167 39.4064ZM111.434 62.0964L110.072 64.1931L115.134 67.4803L113.879 61.5766L111.434 62.0964ZM114.92 78.4985L117.365 77.9787C117.228 77.3302 116.838 76.7629 116.282 76.4018L114.92 78.4985ZM33.7284 72.8988L31.283 73.4186C31.4747 74.3204 32.1472 75.0435 33.0328 75.3001C33.9184 75.5566 34.8733 75.3049 35.5173 74.6451L33.7284 72.8988ZM37.2148 89.3009L35.4259 87.5545C34.842 88.1527 34.5956 89.003 34.7694 89.8206L37.2148 89.3009ZM47.8063 58.4777L49.1679 56.381L47.449 55.2648L46.0174 56.7313L47.8063 58.4777ZM61.0653 67.0882L59.7037 69.1848L61.5803 70.4035L62.9988 68.673L61.0653 67.0882ZM72.4094 53.2481L73.771 51.1515L71.8944 49.9328L70.4759 51.6633L72.4094 53.2481ZM85.6684 61.8586L84.3068 63.9553L86.1253 65.1362L87.5515 63.503L85.6684 61.8586ZM94.86 51.3333L96.2216 49.2366L94.4031 48.0557L92.9769 49.6889L94.86 51.3333ZM51.2927 74.8798L52.6543 72.7831L50.9354 71.6669L49.5037 73.1334L51.2927 74.8798ZM64.5516 83.4902L63.19 85.5869L65.0667 86.8056L66.4851 85.0751L64.5516 83.4902ZM75.8958 69.6502L77.2574 67.5535L75.3808 66.3348L73.9623 68.0654L75.8958 69.6502ZM89.1548 78.2607L87.7932 80.3574L89.6116 81.5383L91.0378 79.9051L89.1548 78.2607ZM98.3463 67.7354L99.7079 65.6387L97.8895 64.4578L96.4633 66.091L98.3463 67.7354ZM121.893 111.303L121.373 108.857L44.8299 125.127L45.3496 127.572L45.8694 130.018L122.413 113.748L121.893 111.303ZM22.1072 18.2252L22.627 20.6706L72.7445 10.0178L72.2247 7.57239L71.7049 5.12702L21.5874 15.7798L22.1072 18.2252ZM72.2247 7.57239L70.9192 9.70446L102.671 29.1463L103.977 27.0142L105.282 24.8821L73.5302 5.44031L72.2247 7.57239ZM103.977 27.0142L103.457 24.5688L77.0313 30.1857L77.5511 32.6311L78.0709 35.0765L104.496 29.4596L103.977 27.0142ZM77.5511 32.6311L79.9965 32.1113L74.6701 7.05261L72.2247 7.57239L69.7793 8.09217L75.1057 33.1509L77.5511 32.6311ZM106.721 39.9262L104.276 40.446L108.988 62.6162L111.434 62.0964L113.879 61.5766L109.167 39.4064L106.721 39.9262ZM114.92 78.4985L112.475 79.0183L119.447 111.822L121.893 111.303L124.338 110.783L117.365 77.9787L114.92 78.4985ZM33.7284 72.8988L36.1738 72.379L24.5525 17.7054L22.1072 18.2252L19.6618 18.745L31.283 73.4186L33.7284 72.8988ZM45.3496 127.572L47.795 127.053L39.6601 88.7811L37.2148 89.3009L34.7694 89.8206L42.9043 128.092L45.3496 127.572ZM33.7284 72.8988L35.5173 74.6451L49.5952 60.224L47.8063 58.4777L46.0174 56.7313L31.9395 71.1524L33.7284 72.8988ZM47.8063 58.4777L46.4447 60.5744L59.7037 69.1848L61.0653 67.0882L62.4269 64.9915L49.1679 56.381L47.8063 58.4777ZM61.0653 67.0882L62.9988 68.673L74.3429 54.8329L72.4094 53.2481L70.4759 51.6633L59.1318 65.5033L61.0653 67.0882ZM72.4094 53.2481L71.0478 55.3448L84.3068 63.9553L85.6684 61.8586L87.03 59.7619L73.771 51.1515L72.4094 53.2481ZM85.6684 61.8586L87.5515 63.503L96.743 52.9777L94.86 51.3333L92.9769 49.6889L83.7854 60.2142L85.6684 61.8586ZM94.86 51.3333L93.4984 53.43L110.072 64.1931L111.434 62.0964L112.795 59.9997L96.2216 49.2366L94.86 51.3333ZM37.2148 89.3009L39.0037 91.0472L53.0816 76.6261L51.2927 74.8798L49.5037 73.1334L35.4259 87.5545L37.2148 89.3009ZM51.2927 74.8798L49.9311 76.9764L63.19 85.5869L64.5516 83.4902L65.9132 81.3936L52.6543 72.7831L51.2927 74.8798ZM64.5516 83.4902L66.4851 85.0751L77.8293 71.235L75.8958 69.6502L73.9623 68.0654L62.6181 81.9054L64.5516 83.4902ZM75.8958 69.6502L74.5342 71.7469L87.7932 80.3574L89.1548 78.2607L90.5164 76.164L77.2574 67.5535L75.8958 69.6502ZM89.1548 78.2607L91.0378 79.9051L100.229 69.3798L98.3463 67.7354L96.4633 66.091L87.2717 76.6162L89.1548 78.2607ZM98.3463 67.7354L96.9847 69.8321L113.558 80.5952L114.92 78.4985L116.282 76.4018L99.7079 65.6387L98.3463 67.7354Z"
        fill="#A0A0AA"
      />
    </SvgIconComponent>
  )
}

export function CopyPin({ size, ...props }) {
  return (
    <SvgIconComponent
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M15.68 8.15847C14.4426 8.11827 13.2398 8.57052 12.3354 9.41601C11.4311 10.2615 10.899 11.4312 10.856 12.6685C10.856 15.9275 15.68 22.0025 15.68 22.0025C15.68 22.0025 20.504 15.9275 20.504 12.6685C20.4609 11.4312 19.9289 10.2615 19.0245 9.41601C18.1201 8.57052 16.9173 8.11827 15.68 8.15847Z"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.33333"
      />
      <path
        d="M13.576 5.74347C13.3429 4.66424 12.7407 3.70012 11.8731 3.01724C11.0054 2.33435 9.92681 1.97549 8.82302 2.00247C7.58565 1.96226 6.38284 2.41451 5.47849 3.26C4.57413 4.1055 4.04207 5.27519 3.99902 6.51247C3.99902 9.77147 8.82302 15.8465 8.82302 15.8465C8.82302 15.8465 9.06402 15.5465 9.43602 15.0375"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function PlaySolid({ fill, size, ...props }) {
  return (
    <SvgIconComponent
      height="25"
      width="25"
      fill={fill ?? 'none'}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M19.5562 12.5549C19.9217 12.7399 19.9217 13.262 19.5562 13.4471L6.94105 19.8335C6.60846 20.0019 6.21521 19.7602 6.21521 19.3874V13.001V6.61451C6.21521 6.24173 6.60846 6.00005 6.94105 6.16842L19.5562 12.5549Z"
        fill={fill ?? '#141A21'}
        fillRule="evenodd"
        stroke={fill ?? '#141A21'}
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
    </SvgIconComponent>
  )
}

export function PlayOutline({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="25"
      width="25"
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M19.1812 12.5549C19.5467 12.7399 19.5467 13.262 19.1812 13.4471L6.56605 19.8335C6.23346 20.0019 5.84021 19.7602 5.84021 19.3874V13.001V6.61451C5.84021 6.24173 6.23346 6.00005 6.56605 6.16842L19.1812 12.5549Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
    </SvgIconComponent>
  )
}

export function PauseSolid({ size, ...props }) {
  return (
    <SvgIconComponent
      height="25"
      width="25"
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <rect
        height="14.22"
        width="4.74"
        fill="#141A21"
        rx="0.79"
        stroke="#141A21"
        strokeLinejoin="round"
        strokeWidth="0.79"
        x="5.07751"
        y="5.69104"
      />
      <rect
        height="14.22"
        width="4.74"
        fill="#141A21"
        rx="0.79"
        stroke="#141A21"
        strokeLinejoin="round"
        strokeWidth="0.79"
        x="14.5576"
        y="5.69116"
      />
    </SvgIconComponent>
  )
}

export function PauseOutline({ size, ...props }) {
  return (
    <SvgIconComponent
      height="25"
      width="25"
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <rect
        height="14.22"
        width="4.74"
        rx="0.79"
        stroke="#141A21"
        strokeLinejoin="round"
        strokeWidth="0.79"
        x="5.70251"
        y="5.69104"
      />
      <rect
        height="14.22"
        width="4.74"
        rx="0.79"
        stroke="#141A21"
        strokeLinejoin="round"
        strokeWidth="0.79"
        x="15.1826"
        y="5.69116"
      />
    </SvgIconComponent>
  )
}

export function Reload({ size, ...props }) {
  return (
    <SvgIconComponent
      height="40"
      width="40"
      fill="none"
      viewBox="8 8 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M30.2998 13.6001L26.1127 13.084C25.991 13.069 25.8811 13.1539 25.8672 13.2736L25.3903 17.3915"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20 11C15.0294 11 11 15.0294 11 20C11 24.9706 15.0294 29 20 29C24.9706 29 29 24.9706 29 20C29 17.5084 27.9875 15.2533 26.3516 13.6237"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function MobileDevice({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width="16"
      fill="none"
      viewBox="7.333 2 15 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <rect
        height="26.6667"
        width="16"
        rx="2.19608"
        stroke={stroke ?? '#141A21'}
        strokeWidth="1.33333"
        x="7.99997"
        y="2.66699"
      />
      <circle
        cx="16.0001"
        cy="25.3333"
        fill={stroke ?? '#141A21'}
        r="1.33333"
      />
    </SvgIconComponent>
  )
}

export function TabletDevice({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width="16"
      fill="none"
      viewBox="7.333 2 15 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <rect
        height="18.6667"
        width="24"
        rx="2.19608"
        stroke={stroke}
        strokeWidth="1.33333"
        x="4"
        y="7"
      />
      <circle cx="7.99984" cy="16.3333" fill={stroke} r="1.33333" />
    </SvgIconComponent>
  )
}

export const LastActivity = ({ size, stroke = '#141A21', ...props }) => (
  <SvgIconComponent
    height="16"
    width="16"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    size={size}
  >
    <path
      d="M13.3333 7.99996C13.3333 5.05444 10.9455 2.66663 7.99999 2.66663C5.05447 2.66663 2.66666 5.05444 2.66666 7.99996C2.66666 10.9455 5.05447 13.3333 7.99999 13.3333C9.78503 13.3333 11.3652 12.4563 12.3333 11.1098M7.99999 4.66663V7.66662C7.99999 7.87646 8.09879 8.07405 8.26666 8.19996L10.6667 9.99996M12 7.33329L13.3333 8.66663L14.6667 7.33329"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
  </SvgIconComponent>
)

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Clear.propTypes = iconPropTypes
Deactivate.propTypes = iconPropTypes
Delete.propTypes = iconPropTypes
Download.propTypes = iconPropTypes
EditMedia.propTypes = iconPropTypes
Edit.propTypes = iconPropTypes
Erase.propTypes = iconPropTypes
PinChangePosition.propTypes = iconPropTypes
PinCopy.propTypes = iconPropTypes
Reactivate.propTypes = iconPropTypes
ReviseRedo.propTypes = iconPropTypes
ReviseUndo.propTypes = iconPropTypes
RotateCounterclockwise.propTypes = iconPropTypes
RotateClockwise.propTypes = iconPropTypes
Send.propTypes = iconPropTypes
Share.propTypes = iconPropTypes
Sort.propTypes = iconPropTypes
FilterDisabled.propTypes = iconPropTypes
FilterEnabled.propTypes = iconPropTypes
Info.propTypes = iconPropTypes
Viewlist.propTypes = iconPropTypes
Settings.propTypes = iconPropTypes
Sortation.propTypes = iconPropTypes
ViewSplit.propTypes = iconPropTypes
ViewTale.propTypes = iconPropTypes
Search.propTypes = iconPropTypes
NotFound.propTypes = iconPropTypes
EmptyState.propTypes = iconPropTypes
CopyPin.propTypes = iconPropTypes
PlaySolid.propTypes = iconPropTypes
PlayOutline.propTypes = iconPropTypes
PauseSolid.propTypes = iconPropTypes
PauseOutline.propTypes = iconPropTypes
Reload.propTypes = iconPropTypes
MobileDevice.propTypes = iconPropTypes
TabletDevice.propTypes = iconPropTypes
LastActivity.propTypes = iconPropTypes

const iconsCore = {
  Clear,
  Deactivate,
  Delete,
  Download,
  EditMedia,
  Edit,
  Erase,
  PinChangePosition,
  PinCopy,
  Reactivate,
  ReviseRedo,
  ReviseUndo,
  RotateCounterclockwise,
  RotateClockwise,
  Send,
  Share,
  Sort,
  FilterDisabled,
  FilterEnabled,
  Info,
  Viewlist,
  Settings,
  Sortation,
  ViewSplit,
  ViewTale,
  Search,
  NotFound,
  EmptyState,
  CopyPin,
  PlaySolid,
  PlayOutline,
  PauseSolid,
  PauseOutline,
  Reload,
  MobileDevice,
  TabletDevice,
  LastActivity
}

export default iconsCore
